import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChatBalloon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={17}
    height={15}
    viewBox='0 0 17 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.2917 2.04166C16.2917 1.47499 15.7959 0.979156 15.2292 0.979156H1.77087C1.20421 0.979156 0.708374 1.47499 0.708374 2.04166V9.83332C0.708374 10.4 1.20421 10.8958 1.77087 10.8958H3.89587V14.4375L7.43754 10.8958H15.2292C15.7959 10.8958 16.2917 10.4 16.2917 9.83332V2.04166Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgChatBalloon;
